module.exports = __webpack_public_path__ + "79744306314bd758d21b4355cbd06a81.png";